<template>
  <!--搜索-->
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="产品编码">
          <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="开单时间" v-if="!searchForm.dateType">
          <el-date-picker
            v-model="searchForm.date"
            unlink-panels
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyyMMdd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开单时间" v-else>
          <el-date-picker
            v-model="searchForm.date"
            unlink-panels
            type="monthrange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyyMM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label=" " label-width="30px">
          <el-switch @change="dateTypeChange" v-model="searchForm.dateType" active-text="月" inactive-text="日" :active-value="true" :inactive-value="false">
          </el-switch>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>

    <!--列表-->
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出 </el-button>
      </template>
      <el-table
        stripe
        border
        ref="table"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableHeight && tableReload"
        v-loading="loading"
      >
        <el-table-column label="图片" prop="" width="70" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.photoUrls && scope.row.photoUrls.length" size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="月份" prop="payMonth" v-if="searchForm.dateType"></el-table-column>
        <el-table-column label="产品编码" prop="productCode" show-overflow-tooltip></el-table-column>
        <el-table-column label="产品名称" prop="productName" show-overflow-tooltip></el-table-column>
        <el-table-column label="开单量" prop="saleNum" align="right"></el-table-column>
        <el-table-column label="金额" prop="saleAmount" align="right"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance';
import { downloadFile } from '@/utils';
import imgShow from '@/views/components/imgShow';
import tableMixin from '@/utils/tableMixin';
import moment from 'moment';
export default {
  name: 'JDProductSalesTable',
  mixins: [tableMixin],
  components: {
    imgShow,
  },
  data() {
    return {
      header_H: '38px',
      searchCollapse: false,
      exportLoading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      imgList: [],
      imgFormVisible: false,
      searchForm: {
        date: [moment().subtract(1, 'months').format('YYYYMMDD'), moment().subtract('days').format('YYYYMMDD')],
        dateType: false,
      },
      exportData: {},
      currencyForm: {
        pageSize: 30,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'Y',
        groupAttr: '',
      },
    };
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 285;
    },
    windowWidth() {
      return document.body.clientWidth;
    },
    reportName() {
      return this.searchForm.dateType ? 'JingDongSelfMonthSale' : 'JingDongSelfDailySale';
    },
  },
  methods: {
    dateTypeChange() {
      if (this.searchForm.dateType) {
        this.$set(this.searchForm, 'date', [moment().subtract(1, 'months').format('YYYYMM'), moment().subtract('days').format('YYYYMM')]);
      } else {
        this.$set(this.searchForm, 'date', [moment().subtract(1, 'months').format('YYYYMMDD'), moment().subtract('days').format('YYYYMMDD')]);
      }
      this.onSearch();
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let dateType = this.searchForm.dateType;
      let { productCode, productName, date } = this.searchForm;
      let dateIf = date && date.length;
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {
          productCode,
          productName,
          startTime: dateIf && !dateType ? date[0] : dateIf && dateType ? moment(date[0]).startOf('month').format('YYYYMMDD') : '',
          endTime: dateIf && !dateType ? date[1] : dateIf && dateType ? moment(date[1]).endOf('month').format('YYYYMMDD') : '',
        },
        queryMatch: [],
        orderList: [],
        orderByColumn: '',
        orderType: '',
        hasCount: 'Y',
      };
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            res.data.list = res.data.list
              ? res.data.list.map((v) => {
                  return {
                    ...v,
                    flag: false,
                  };
                })
              : [];
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    reset() {
      if (this.$refs['table']) {
        this.$refs['table'].clearSort(); //切换清除排序
      }
      // this.filterPropertyName = [];
      this.searchForm = {
        date: [moment().subtract(1, 'months').format('YYYYMMDD'), moment().subtract('days').format('YYYYMMDD')],
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    async del(row) {
      let status = await this.$confirm('是否确认删除该条数据？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let res = await this.$q.clearanceManagement.exitMarketPackDel({ fragment: [row.dataId] });
      if (res.success) {
        this.$message.success('删除成功');
      } else {
        this.$message.fail('删除失败');
      }
      this.init();
    },

    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.photoUrls.split('|');
      this.imgList = list;
    },

    // 导出
    exportExcel() {
      this.exportLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      if (!this.searchForm.dateType) {
        this.dayExport();
      } else {
        this.monthExport();
      }
    },
    dayExport() {
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData,
        },
        reportName: this.reportName,
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
        } else {
          this.$message.error(res.message);
        }
        this.exportLoading.close();
      });
    },
    monthExport() {
      let data = {
        ...this.searchFormData.param,
      };
      this.$q.smallHomeAppliances.jdProductExport({ data: data, options: { responseType: 'blob' } }).then((res) => {
        let fileName = '京东自营入仓产品销量-月维度' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.blobDownload(res, `${fileName}.XLSX`);
        this.exportLoading.close();
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
